import React from 'react';
import { Helmet } from 'react-helmet';
import { Global, css } from '@emotion/react';
import { lighten } from 'polished';

import favicon from '../../src/favicon.ico';
import { colors } from '../styles/colors';

interface IndexProps {
  className?: string;
  children: React.ReactNode;
}

function IndexLayout(props: IndexProps) {
  return (
    <div className={props.className}>
      <Helmet>
        <link rel="icon" href={favicon} type="image/x-icon" />
      </Helmet>
      <Global
        styles={css`
          html,
          body,
          div,
          span,
          applet,
          object,
          iframe,
          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          p,
          blockquote,
          pre,
          a,
          abbr,
          acronym,
          address,
          big,
          cite,
          code,
          del,
          dfn,
          em,
          img,
          ins,
          kbd,
          q,
          s,
          samp,
          small,
          strike,
          strong,
          sub,
          sup,
          tt,
          var,
          dl,
          dt,
          dd,
          ol,
          ul,
          li,
          fieldset,
          form,
          label,
          legend,
          table,
          caption,
          tbody,
          tfoot,
          thead,
          tr,
          th,
          td,
          article,
          aside,
          canvas,
          details,
          embed,
          figure,
          figcaption,
          footer,
          header,
          hgroup,
          menu,
          nav,
          output,
          ruby,
          // section,
          summary,
          time,
          mark,
          audio,
          video {
            margin: 0;
            padding: 0;
            border: 0;
            font: inherit;
            font-size: 90%;
            align-content: center;
          }
          section,
          {
            font-size: 1.4rem;
          }
          body {
            line-height: 1;
          }
          ol,
          ul {
            list-style: none;
          }
          blockquote,
          q {
            quotes: none;
          }
          blockquote:before,
          blockquote:after,
          q:before,
          q:after {
            content: '';
            content: none;
          }
          table {
            border-spacing: 0;
            border-collapse: collapse;
          }
          img {
            max-width: 100%;
          }
          html {
            box-sizing: border-box;
            font-family: sans-serif;

            -ms-text-size-adjust: 100%;
            -webkit-text-size-adjust: 100%;
          }
          *,
          *:before,
          *:after {
            box-sizing: inherit;
          }
          a {
            background-color: transparent;
          }
          a:active,
          a:hover {
            outline: 0;
          }
          b,
          strong {
            font-weight: bold;
          }
          i,
          em,
          dfn {
            font-style: italic;
          }
          h1 {
            margin: 0.67em 0;
            font-size: 2em;
          }
          small {
            font-size: 80%;
          }
          sub,
          sup {
            position: relative;
            font-size: 75%;
            line-height: 0;
            vertical-align: baseline;
          }
          sup {
            top: -0.5em;
          }
          sub {
            bottom: -0.25em;
          }
          img {
            border: 0;
          }
          svg:not(:root) {
            overflow: hidden;
          }
          mark {
            background-color: #fdffb6;
          }
          code,
          kbd,
          pre,
          samp {
            font-family: sans-serif;
            font-size: 1em;
          }
          button,
          input,
          optgroup,
          select,
          textarea {
            margin: 0;
            color: inherit;
            font: inherit;
          }
          button {
            overflow: visible;
            border: none;
          }
          button,
          select {
            text-transform: none;
          }
          button,
          html input[type='button'],
          input[type='reset'],
          input[type='submit'] {
            cursor: pointer;

            -webkit-appearance: button;
          }
          button[disabled],
          html input[disabled] {
            cursor: default;
          }
          button::-moz-focus-inner,
          input::-moz-focus-inner {
            padding: 0;
            border: 0;
          }
          input {
            line-height: normal;
          }
          input:focus {
            outline: none;
          }
          input[type='checkbox'],
          input[type='radio'] {
            box-sizing: border-box;
            padding: 0;
          }
          input[type='number']::-webkit-inner-spin-button,
          input[type='number']::-webkit-outer-spin-button {
            height: auto;
          }
          input[type='search'] {
            box-sizing: content-box;

            -webkit-appearance: textfield;
          }
          input[type='search']::-webkit-search-cancel-button,
          input[type='search']::-webkit-search-decoration {
            -webkit-appearance: none;
          }
          legend {
            padding: 0;
            border: 0;
          }
          textarea {
            overflow: auto;
          }
          table {
            border-spacing: 0;
            border-collapse: collapse;
          }
          td,
          th {
            padding: 0;
          }

          html {
            overflow-x: hidden;
            overflow-y: scroll;
            font-size: 62.5%;

            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
          }
          body {
            overflow-x: hidden;
            color: ${lighten('-0.3', colors.midgrey)};
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu,
              Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
            font-size: 1.6rem;
            line-height: 1.6em;
            font-weight: 400;
            font-style: normal;
            letter-spacing: 0;
            text-rendering: optimizeLegibility;
            background: #fff;

            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            -moz-font-feature-settings: 'liga' on;
          }

          ::selection {
            text-shadow: none;
            background: ${lighten('0.3', colors.blue)};
          }

          hr {
            position: relative;
            display: block;
            width: 100%;
            margin: 2.5em 0 3.5em;
            padding: 0;
            height: 1px;
            border: 0;
            border-top: 1px solid ${lighten('0.1', colors.lightgrey)};
          }

          audio,
          canvas,
          iframe,
          img,
          svg,
          video {
            vertical-align: middle;
          }

          fieldset {
            margin: 0;
            padding: 0;
            border: 0;
          }

          textarea {
            resize: vertical;
          }

          p,
          ul,
          // ol,
          dl,
          blockquote {
            margin: 0 0 1.3em 0;
          }

          ol,
          ul {
            padding-left: 1.3em;
            padding-right: 1.5em;
          }

          ol ol,
          ul ul,
          ul ol,
          ol ul {
            // margin: 0.5em 0 1em;
          }

          ul {
            list-style: disc;
          }

          ol {
            list-style: decimal;
          }

          ul,
          ol {
            max-width: 100%;
          }

          li {
            margin: 0.5em 0;
            padding-left: 0.3em;
            line-height: 1.4em;
            font-size: 1.6rem
          }

          dt {
            float: left;
            margin: 0 20px 0 0;
            width: 120px;
            color: ${colors.darkgrey};
            font-weight: 500;
            text-align: right;
          }

          dd {
            margin: 0 0 5px 0;
            text-align: left;
          }

          blockquote {
            margin: 1.5em 0;
            padding: 0 1.6em 0 1.6em;
            border-left: ${colors.whitegrey} 0.5em solid;
          }

          blockquote p {
            margin: 0.8em 0;
            font-size: 1.2em;
            font-weight: 300;
          }

          blockquote small {
            display: inline-block;
            margin: 0.8em 0 0.8em 1.5em;
            font-size: 0.9em;
            opacity: 0.8;
          }

          blockquote cite {
            font-weight: bold;
          }
          blockquote cite a {
            font-weight: normal;
          }

          a {
            color: ${lighten('-0.05', colors.blue)};
            text-decoration: none;
          }

          a:hover {
            text-decoration: underline;
          }

          h1,
          h2,
          h3,
          h4,
          h5,
          h6 {
            margin-top: 0;
            line-height: 1.15;
            font-weight: 600;
            text-rendering: optimizeLegibility;
          }

          h1 {
            margin: 0 0 0.5em 0;
            font-size: 4.2rem;
            font-weight: 600;
          }
          @media (max-width: 500px) {
            h1 {
              font-size: 2.2rem;
            }
          }

          h2 {
            margin: 1.5em 0 0.5em 0;
            font-size: 2.2rem;
          }
          @media (max-width: 500px) {
            h2 {
              font-size: 1.8rem;
            }
          }

          h3 {
            margin: 1.5em 0 0.5em 0;
            font-size: 1.8rem;
            font-weight: 500;
          }
          @media (max-width: 500px) {
            h3 {
              font-size: 1.7rem;
            }
          }

          h4 {
            margin: 1.5em 0 0.5em 0;
            font-size: 1.6rem;
            font-weight: 500;
          }

          h5 {
            margin: 1.5em 0 0.5em 0;
            font-size: 1.4rem;
            font-weight: 500;
          }

          h6 {
            margin: 1.5em 0 0.5em 0;
            font-size: 1.4rem;
            font-weight: 500;
          }

          /* globals from screen.css */
          body {
            background: #fff;
          }

          @media (prefers-color-scheme: dark) {
            body {
              color: rgba(255, 255, 255, 0.85);
              background: ${colors.darkmode};
            }
            img {
              opacity: 0.9;
            }
          }
          /*=================================================================================
            カエレバ・ヨメレバ・トマレバ
          =================================================================================*/

          .appreach-info,
          .cstmreba{
            width:98%;
            height:auto;
            margin:36px auto;
            font-family:'Lucida Grande','Hiragino Kaku Gothic ProN',Helvetica, Meiryo, sans-serif;
            line-height: 1.5;
            word-wrap: break-word;
            box-sizing: border-box;
            display: block;
          }
          /* WordPressで自動挿入されるPタグの余白を対処 */
          .cstmreba p {
            margin: 0;
            padding: 0;
          }
          .cstmreba a {
            transition: 0.8s ;
            color:#285EFF; /* テキストリンクカラー */
          }
          .cstmreba a:hover {
            color:#FFCA28; /* テキストリンクカラー(マウスオーバー時) */
          }
          @media (prefers-color-scheme: light) {
            .cstmreba .booklink-box,
            .cstmreba .kaerebalink-box,
            .cstmreba .tomarebalink-box{
              background-color: ${colors.light_kaereba};
              // box-shadow: 0 12px 26px rgba(0, 0, 0, 0.4);
              width: 100%;
              overflow: hidden;
              border-radius: 0px;
              box-sizing: border-box;
              padding: 12px 8px;
              box-shadow: 0px 2px 5px 0 rgba(0,0,0,.26);
            }
          }

          @media (prefers-color-scheme: dark) {
            .cstmreba,
            .cstmreba .booklink-box,
            .cstmreba .kaerebalink-box,
            .cstmreba .tomarebalink-box{
              /* background: color(var(--darkmode) l(+4%)); */
              background-color: ${colors.darkmode_kaereba};
              // box-shadow: 0 12px 26px rgba(0, 0, 0, 0.4);
              width: 100%;
              overflow: hidden;
              border-radius: 0px;
              box-sizing: border-box;
              padding: 12px 8px;
              box-shadow: 0px 2px 5px 0 rgba(0,0,0,.26);
            } 
          }
          /* サムネイル画像ボックス */
          .cstmreba .booklink-image,
          .cstmreba .kaerebalink-image,
          .cstmreba .tomarebalink-image {
            width:180px;
            float:left;
            margin:0 14px 0 0;
            text-align: center;
            background: #fff;
          }
          .cstmreba .booklink-image a,
          .cstmreba .kaerebalink-image a,
          .cstmreba .tomarebalink-image a {
            width:180px;
            text-align: -webkit-center;
            display:block;
          }
          @media screen and (max-width:768px) {
            .cstmreba .booklink-image a,
            .cstmreba .kaerebalink-image a,
            .cstmreba .tomarebalink-image a {
              width:180px;
              text-align: -webkit-center;
              display:block;
            }
          }
          .cstmreba .booklink-image a img,
          .cstmreba .kaerebalink-image a img,
          .cstmreba .tomarebalink-image a img {
            margin:0 ;
            padding: 0;
            text-align:center;
            background: #fff;
            // max-width: 180px;
          }
          .cstmreba .booklink-info,.cstmreba .kaerebalink-info,.cstmreba .tomarebalink-info {
            overflow:hidden;
            line-height:170%;
            color: #b5c9d2;
          }
          /* infoボックス内リンク下線非表示 */
          .cstmreba .booklink-info a,
          .cstmreba .kaerebalink-info a,
          .cstmreba .tomarebalink-info a {
            text-decoration: none;
          }
          /* 作品・商品・ホテル名 リンク */
          .appreach-info,
          .cstmreba .booklink-name>a,
          .cstmreba .kaerebalink-name>a,
          .cstmreba .tomarebalink-name>a {
            font-size:16px;
          }
          /* powered by */
          .cstmreba .booklink-powered-date,
          .cstmreba .kaerebalink-powered-date,
          .cstmreba .tomarebalink-powered-date {
            font-size:10px;
            line-height:150%;
          }
          .cstmreba .booklink-powered-date a,
          .cstmreba .kaerebalink-powered-date a,
          .cstmreba .tomarebalink-powered-date a {
            color:#b5c9d2;
            border-bottom: none ;
          }
          .cstmreba .booklink-powered-date a:hover,
          .cstmreba .kaerebalink-powered-date a:hover,
          .cstmreba .tomarebalink-powered-date a:hover {
            color:#b5c9d2;
            border-bottom: 1px solid #333 ;
          }
          /* 著者・住所 */
          .cstmreba .booklink-detail,.cstmreba .kaerebalink-detail,.cstmreba .tomarebalink-address {
            font-size:12px;
          }
          .cstmreba .kaerebalink-link1 div img,.cstmreba .booklink-link2 div img,.cstmreba .tomarebalink-link1 div img {
            display:none !important;
          }
          .cstmreba .kaerebalink-link1, .cstmreba .booklink-link2,.cstmreba .tomarebalink-link1 {
            display: inline-block;
            width: 100%;
            margin-top: 5px;
          }
          .cstmreba .booklink-link2>div,
          .cstmreba .kaerebalink-link1>div,
          .cstmreba .tomarebalink-link1>div {
            float:left;
            width:24%;
            min-width:128px;
            margin:0.5%;
          }
          /***** ボタンデザインここから ******/
          .cstmreba .booklink-link2 a,
          .cstmreba .kaerebalink-link1 a,
          .cstmreba .tomarebalink-link1 a {
            width: 100%;
            display: inline-block;
            text-align: center;
            box-sizing: border-box;
            margin: 1px 0;
            padding:3% 0.5%;
            border-radius: 8px;
            font-size: 13px;
            font-weight: bold;
            line-height: 180%;
            color: #fff;
            box-shadow: 0px 2px 4px 0 rgba(0,0,0,.26);
          }
          /* トマレバ */
          .cstmreba .tomarebalink-link1 .shoplinkrakuten a {background: #76ae25; border: 2px solid #76ae25; }/* 楽天トラベル */
          .cstmreba .tomarebalink-link1 .shoplinkjalan a { background: #ff7a15; border: 2px solid #ff7a15;}/* じゃらん */
          .cstmreba .tomarebalink-link1 .shoplinkjtb a { background: #c81528; border: 2px solid #c81528;}/* JTB */
          .cstmreba .tomarebalink-link1 .shoplinkknt a { background: #0b499d; border: 2px solid #0b499d;}/* KNT */
          .cstmreba .tomarebalink-link1 .shoplinkikyu a { background: #bf9500; border: 2px solid #bf9500;}/* 一休 */
          .cstmreba .tomarebalink-link1 .shoplinkrurubu a { background: #000066; border: 2px solid #000066;}/* るるぶ */
          .cstmreba .tomarebalink-link1 .shoplinkyahoo a { background: #ff0033; border: 2px solid #ff0033;}/* Yahoo!トラベル */
          .cstmreba .tomarebalink-link1 .shoplinkhis a { background: #004bb0; border: 2px solid #004bb0;}/*** HIS ***/
          /* カエレバ */
          .cstmreba .kaerebalink-link1 .shoplinkyahoo a {background:#ff0033; border:2px solid #ff0033; letter-spacing:normal;} /* Yahoo!ショッピング */
          .cstmreba .kaerebalink-link1 .shoplinkbellemaison a { background:#84be24 ; border: 2px solid #84be24;}	/* ベルメゾン */
          .cstmreba .kaerebalink-link1 .shoplinkcecile a { background:#8d124b; border: 2px solid #8d124b;} /* セシール */
          .cstmreba .kaerebalink-link1 .shoplinkwowma a { background:#ea5404; border: 2px solid #ea5404;} /* Wowma */
          .cstmreba .kaerebalink-link1 .shoplinkkakakucom a {background:#314995; border: 2px solid #314995;} /* 価格コム */
          /* ヨメレバ */
          .cstmreba .booklink-link2 .shoplinkkindle a { background:#007dcd; border: 2px solid #007dcd;} /* Kindle */
          .cstmreba .booklink-link2 .shoplinkrakukobo a { background:#bf0000; border: 2px solid #bf0000;} /* 楽天kobo */
          .cstmreba .booklink-link2  .shoplinkbk1 a { background:#0085cd; border: 2px solid #0085cd;} /* honto */
          .cstmreba .booklink-link2 .shoplinkehon a { background:#2a2c6d; border: 2px solid #2a2c6d;} /* ehon */
          .cstmreba .booklink-link2 .shoplinkkino a { background:#003e92; border: 2px solid #003e92;} /* 紀伊國屋書店 */
          .cstmreba .booklink-link2 .shoplinkebj a { background:#f8485e; border: 2px solid #f8485e;} /* ebookjapan */
          .cstmreba .booklink-link2 .shoplinktoshokan a { background:#333333; border: 2px solid #333333;} /* 図書館 */
          /* カエレバ・ヨメレバ共通 */
          .cstmreba .kaerebalink-link1 .shoplinkamazon a,
          .cstmreba .booklink-link2 .shoplinkamazon a {
            background:#FF9901;
            border: 2px solid #ff9901;
          } /* Amazon */
          .cstmreba .kaerebalink-link1 .shoplinkrakuten a,
          .cstmreba .booklink-link2 .shoplinkrakuten a {
            background: #bf0000;
            border: 2px solid #bf0000;
          } /* 楽天 */
          .cstmreba .kaerebalink-link1 .shoplinkseven a,
          .cstmreba .booklink-link2 .shoplinkseven a {
            background:#225496;
            border: 2px solid #225496;
          } /* 7net */
          /****** ボタンカラー ここまで *****/

          /***** ボタンデザイン　マウスオーバー時ここから *****/
          .cstmreba .booklink-link2 a:hover,
          .cstmreba .kaerebalink-link1 a:hover,
          .cstmreba .tomarebalink-link1 a:hover {
            background: #fff;
          }
          /* トマレバ */
          .cstmreba .tomarebalink-link1 .shoplinkrakuten a:hover { color: #76ae25; }/* 楽天トラベル */
          .cstmreba .tomarebalink-link1 .shoplinkjalan a:hover { color: #ff7a15; }/* じゃらん */
          .cstmreba .tomarebalink-link1 .shoplinkjtb a:hover { color: #c81528; }/* JTB */
          .cstmreba .tomarebalink-link1 .shoplinkknt a:hover { color: #0b499d; }/* KNT */
          .cstmreba .tomarebalink-link1 .shoplinkikyu a:hover { color: #bf9500; }/* 一休 */
          .cstmreba .tomarebalink-link1 .shoplinkrurubu a:hover { color: #000066; }/* るるぶ */
          .cstmreba .tomarebalink-link1 .shoplinkyahoo a:hover { color: #ff0033; }/* Yahoo!トラベル */
          .cstmreba .tomarebalink-link1 .shoplinkhis a:hover { color: #004bb0; }/*** HIS ***/
          /* カエレバ */
          .cstmreba .kaerebalink-link1 .shoplinkyahoo a:hover {color:#ff0033;} /* Yahoo!ショッピング */
          .cstmreba .kaerebalink-link1 .shoplinkbellemaison a:hover { color:#84be24 ; }	/* ベルメゾン */
          .cstmreba .kaerebalink-link1 .shoplinkcecile a:hover { color:#8d124b; } /* セシール */
          .cstmreba .kaerebalink-link1 .shoplinkwowma a:hover { color:#ea5404; } /* Wowma */
          .cstmreba .kaerebalink-link1 .shoplinkkakakucom a:hover {color:#314995;} /* 価格コム */
          /* ヨメレバ */
          .cstmreba .booklink-link2 .shoplinkkindle a:hover { color:#007dcd;} /* Kindle */
          .cstmreba .booklink-link2 .shoplinkrakukobo a:hover { color:#bf0000; } /* 楽天kobo */
          .cstmreba .booklink-link2 .shoplinkbk1 a:hover { color:#0085cd; } /* honto */
          .cstmreba .booklink-link2 .shoplinkehon a:hover { color:#2a2c6d; } /* ehon */
          .cstmreba .booklink-link2 .shoplinkkino a:hover { color:#003e92; } /* 紀伊國屋書店 */
          .cstmreba .booklink-link2 .shoplinkebj a:hover { color:#f8485e; } /* ebookjapan */
          .cstmreba .booklink-link2 .shoplinktoshokan a:hover { color:#333333; } /* 図書館 */
          /* カエレバ・ヨメレバ共通 */
          .cstmreba .kaerebalink-link1 .shoplinkamazon a:hover,
          .cstmreba .booklink-link2 .shoplinkamazon a:hover {
            color:#FF9901; } /* Amazon */
          .cstmreba .kaerebalink-link1 .shoplinkrakuten a:hover,
          .cstmreba .booklink-link2 .shoplinkrakuten a:hover {
            color: #bf0000; } /* 楽天 */
          .cstmreba .kaerebalink-link1 .shoplinkseven a:hover,
          .cstmreba .booklink-link2 .shoplinkseven a:hover {
            color:#225496;} /* 7net */
          /***** ボタンデザイン　マウスオーバー時ここまで *****/
          .cstmreba .booklink-footer {
            clear:both;
          }

          /*****  解像度768px以下のスタイル *****/
          @media screen and (max-width:768px){
            .cstmreba .booklink-image,
            .cstmreba .kaerebalink-image,
            .cstmreba .tomarebalink-image {
              width:100%;
              text-align: -webkit-center;
              float:none;

            }
            .cstmreba .booklink-link2>div,
            .cstmreba .kaerebalink-link1>div,
            .cstmreba .tomarebalink-link1>div {
              width: 32.33%;
              margin: 0.5%;
            }
            .cstmreba .booklink-info,
            .cstmreba .kaerebalink-info,
            .cstmreba .tomarebalink-info {
              text-align:center;
              padding-bottom: 1px;
            }
          }

          /*****  解像度480px以下のスタイル *****/
          @media screen and (max-width:480px){
            .cstmreba .booklink-link2>div,
            .cstmreba .kaerebalink-link1>div,
            .cstmreba .tomarebalink-link1>div {
              width: 49%;
              margin: 0.5%;
            }
          }
        `}
      />
      {props.children}
    </div>
  );
}

export default IndexLayout;
